import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';


@Component({
    selector: 'eas-editor-eligibility-rule-form-is-raw-operator',
    templateUrl: './editor-eligibility-rule-form-is-raw-operator.component.html',
    standalone: false
})
export class EditorEligibilityRuleFormIsRawOperatorComponent implements OnInit {
  @Input() formGroup: FormGroup;

  constructor() {

  }

  ngOnInit() {

  }

  getFormControl(name): FormControl {
    return this.formGroup.controls[name] as FormControl;
  }
}
